import { render, staticRenderFns } from "./ContactRoute.vue?vue&type=template&id=1394f774&scoped=true&"
import script from "./ContactRoute.vue?vue&type=script&lang=js&"
export * from "./ContactRoute.vue?vue&type=script&lang=js&"
import style0 from "./ContactRoute.vue?vue&type=style&index=0&id=1394f774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394f774",
  null
  
)

export default component.exports